var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalander(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.46289 3.6C1.46289 3.16508 1.81547 2.8125 2.25039 2.8125H15.7504C16.1853 2.8125 16.5379 3.16508 16.5379 3.6V15.75C16.5379 16.1849 16.1853 16.5375 15.7504 16.5375H2.25039C1.81547 16.5375 1.46289 16.1849 1.46289 15.75V3.6ZM3.03789 4.3875V14.9625H14.9629V4.3875H3.03789Z",
    fill: "#EFEFEF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6383 9.11211H2.36328V7.53711H15.6383V9.11211Z",
    fill: "#EFEFEF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.96328 1.46289C6.3982 1.46289 6.75078 1.81547 6.75078 2.25039V5.28789C6.75078 5.72282 6.3982 6.07539 5.96328 6.07539C5.52836 6.07539 5.17578 5.72282 5.17578 5.28789V2.25039C5.17578 1.81547 5.52836 1.46289 5.96328 1.46289Z",
    fill: "#EFEFEF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9242 1.46289C12.3591 1.46289 12.7117 1.81547 12.7117 2.25039V5.28789C12.7117 5.72282 12.3591 6.07539 11.9242 6.07539C11.4893 6.07539 11.1367 5.72282 11.1367 5.28789V2.25039C11.1367 1.81547 11.4893 1.46289 11.9242 1.46289Z",
    fill: "#EFEFEF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5 12.0375C4.5 11.6026 4.85258 11.25 5.2875 11.25H12.7125C13.1474 11.25 13.5 11.6026 13.5 12.0375C13.5 12.4724 13.1474 12.825 12.7125 12.825H5.2875C4.85258 12.825 4.5 12.4724 4.5 12.0375Z",
    fill: "#EFEFEF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalander);
export default __webpack_public_path__ + "static/media/Calander.f4c857f2017db1c764f9d6fab647ffc3.svg";
export { ForwardRef as ReactComponent };